import { PAGE_NAME_TEMPLATE } from './deferred-send/constants';

/**
 * Опции для построения RumId.
 */
interface BuildRumIdOptions {
    /**
     * Имя проекта в Rum.
     */
    project: string;
    /**
     * Имя сервиса.
     */
    service?: string;
    /**
     * Имя платформы.
     */
    platform: string;
}

/**
 * Построение rum_id для page'ей и subpage'ей.
 *
 * @kind helper
 * @param options Опции для формирования rum_id.
 * @return Правильный rum_id для MPA и SPA страниц.
 */
export function buildRumId({ project, service, platform }: BuildRumIdOptions) {
    return `ru.${project}${service ? `.${service}` : ''}.${platform}.${PAGE_NAME_TEMPLATE}`;
}
